import { Box, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import {
  getHistoryTimeArea,
  putEndRegionTime,
  putStartRegionTime,
} from "../../api/area";
import stopwatch from "../../assets/image/stopwatch.png";
import ClockIcon from "../../assets/SVG/clockIcon";

export default function HistoryArea({ setOpen, open, dataArea }) {
  // const [open, setOpen] = useState(false);
  const [start, setStart] = useState(false);
  const [dataTime, setDataTime] = useState();
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (dataArea) {
      getHistoryTimeArea(dataArea[0]?.areas[0]?.id)
        .then((x) => setDataTime(x))
        .catch(() => {});
    }
  }, [dataArea]);
  useEffect(() => {
    if (dataTime) {
      for (let i = 0; i < dataTime.length; i++) {
        if (dataTime.length === i + 1) {
          if (!dataTime[i].end) {
            setStart(true);
          }
        }
      }
    }
  }, [dataTime]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      //   sx={{}}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 750,
          height: 350,
          bgcolor: "white",
          boxShadow: 24,
          p: 5,
          borderRadius: "23px",
          ":focus-visible": {
            outline: "none !important",
            border: "none !important",
          },
        }}
      >
        <Box display="flex" alignItems="center" gap="20px">
          <Box
            width="40%"
            textAlign="center"
            borderLeft="1px solid #98C2CB"
            height={"350px"}
          >
            <img
              src={stopwatch}
              style={{ marginLeft: "50px", height: "200px" }}
            />
            <Box display="flex" justifyContent={"center"}>
              {!start && (
                <Box
                  width="80px"
                  mt="40px"
                  borderRadius="9px"
                  p="3px"
                  color="white"
                  bgcolor="#00C67E"
                  marginLeft="50px"
                  sx={{cursor:"pointer"}}
                  onClick={() => {
                    putStartRegionTime(dataArea[0]?.areas[0]?.id)
                      .then((x) => {
                        setStart(true);
                        getHistoryTimeArea(dataArea[0]?.areas[0]?.id)
                        .then((x) => setDataTime(x))
                        .catch(() => {});
                      })
                      .catch(() => {});
                  }}
                >
                  شروع
                </Box>
              )}
              {start && (
                <Box
                  width="80px"
                  mt="40px"
                  borderRadius="9px"
                  p="3px"
                  color="white"
                  bgcolor="#D98D33"
                  marginLeft="50px"
                  sx={{cursor:"pointer"}}
                  onClick={() => {
                    putEndRegionTime(dataArea[0]?.areas[0]?.id)
                      .then((x) => {
                        setStart(false);
                        getHistoryTimeArea(dataArea[0]?.areas[0]?.id)
                        .then((x) => setDataTime(x))
                        .catch(() => {});
                      })
                      .catch(() => {});
                  }}
                >
                  توقف
                </Box>
              )}
            </Box>
          </Box>
          <Box  height="300px" pl="20px">
            <Typography color="black" fontWeight="bold" fontSize="20px" >تاریخچه</Typography>
            {dataTime?.map((x, i) => (
              <>
                <Box mt="20px" display="flex" gap="15px">
                  <ClockIcon />
                  <Typography color="#878686" >{x.start.split(" ", 4)[0]}</Typography>
                  <Typography color="#878686" >{` شروع اول :  ${
                    x.start.split(" ", 4)[0]
                  }`}</Typography>
                </Box>
                {x.end && (
                  <Box mt="10px" display="flex" gap="15px">
                    <ClockIcon />
                    <Typography color="#878686" >{x.end.split(" ", 4)[0]}</Typography>
                    <Typography color="#878686" >{` توقف اول :  ${
                      x.end.split(" ", 4)[0]
                    }`}</Typography>
                  </Box>
                )}
              </>
            ))}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
